export const TRUSTED_GROUP = "trusted";